import type { Station as StationData } from '@/content/schema';
import { Suspense, useCallback, useRef, useState } from 'react';
import * as THREE from 'three';
import { GlbLayer, type LayerHandle } from './GlbLayer';
import { Placeholder } from './Hero';

export function StationAnchor({ station }: { station: StationData }) {
  const handles = useRef(new Map<string, LayerHandle>());
  const [offset, setOffset] = useState<[number, number, number]>([0, 0, 0]);

  const onLayerReady = useCallback((id: string, handle: LayerHandle | null) => {
    if (handle) handles.current.set(id, handle);
    else handles.current.delete(id);
    if (handles.current.size === 0) return;
    const union = new THREE.Box3();
    for (const h of handles.current.values()) union.union(h.box);
    const centre = union.getCenter(new THREE.Vector3());
    setOffset([-centre.x, -union.min.y, -centre.z]);
  }, []);

  if (station.layers.length === 0 && !station.placeholder) return null;

  return (
    <group position={station.position} rotation-y={station.rotationY} scale={station.scale}>
      {station.layers.length > 0 ? (
        <Suspense fallback={<Placeholder />}>
          <group position={offset}>
            {station.layers.map((layer) => (
              <GlbLayer key={layer.id} model={layer} onReady={onLayerReady} />
            ))}
          </group>
        </Suspense>
      ) : (
        <Placeholder />
      )}
    </group>
  );
}
